import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ItemType3dIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M9.34995 11.84C10.0699 11.71 10.6799 11.13 10.6799 10.24C10.6799 9.12001 9.70995 8.39001 8.20995 8.39001C7.00995 8.39001 6.32995 8.87001 5.79995 9.56001L6.73995 10.44C7.08995 9.91001 7.59995 9.61001 8.15995 9.61001C8.74995 9.61001 9.09995 9.99001 9.09995 10.49C9.09995 10.92 8.76995 11.27 8.02995 11.27H7.37995V12.52H8.00995C8.76995 12.52 9.22995 12.84 9.22995 13.41C9.22995 13.98 8.82995 14.39 8.14995 14.39C7.39995 14.39 6.97995 13.98 6.67995 13.41L5.56995 14.27C6.01995 14.98 6.72995 15.61 8.14995 15.61C9.72995 15.61 10.7999 14.8 10.7999 13.55C10.7999 12.59 10.1799 11.99 9.34995 11.84Z"
        fill={color}
      />
      <path
        d="M15 8.51001H12.37V15.49H15C16.85 15.49 18.07 14.32 18.07 12C18.07 9.68001 16.85 8.51001 15 8.51001ZM16.46 12.54C16.46 13.65 15.9 14.14 15 14.14H13.89V9.86001H15C15.9 9.86001 16.46 10.35 16.46 11.46V12.54Z"
        fill={color}
      />
      <path
        d="M21.27 5.02L13.38 0.440002C12.53 -0.0599976 11.47 -0.0599976 10.62 0.440002L2.72999 5.02C1.88999 5.51 1.35999 6.42 1.35999 7.4V16.6C1.35999 17.58 1.87999 18.49 2.72999 18.98L10.62 23.57C11.47 24.07 12.53 24.07 13.38 23.57L21.27 18.98C22.11 18.49 22.64 17.58 22.64 16.6V7.4C22.64 6.42 22.12 5.51 21.27 5.02ZM21.14 16.6C21.14 17.04 20.9 17.46 20.52 17.68L12.63 22.27C12.24 22.49 11.76 22.49 11.37 22.27L3.47999 17.68C3.09999 17.46 2.85999 17.04 2.85999 16.6V7.4C2.85999 6.96 3.09999 6.54 3.47999 6.32L11.37 1.73C11.76 1.51 12.24 1.51 12.63 1.73L20.52 6.32C20.9 6.54 21.14 6.96 21.14 7.4V16.6Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ItemType3dIcon.displayName = 'ItemType3dIcon';
